
import React, { useState } from 'react';

import './InvoiceCreationForm.css';


const InvoiceCreationForm = ({ content }) => {

  const [form, setForm] = useState({
    client: '',
    date: '',
    dueDate: '',
    series: '',
    number: '',
    currency: 'RON',
  });

  const [product, setProduct] = useState({
    name: '',
    unit: 'buc',
    quantity: '',
    price: '',
    vatRate: '21',
  });

  const [items, setItems] = useState([]);


  const updateForm = (field, value) => {
    setForm(previous => ({
      ...previous,
      [field]: value,
    }));
  };


  const updateProduct = (field, value) => {
    setProduct(previous => ({
      ...previous,
      [field]: value,
    }));
  };


  const addProduct = () => {

    const quantity = Number(product.quantity);
    const price = Number(product.price);
    const vatRate = Number(product.vatRate);

    if (
      !product.name.trim() ||
      !Number.isFinite(quantity) ||
      !Number.isFinite(price) ||
      quantity <= 0 ||
      price < 0
    ) {
      return;
    }

    const value = quantity * price;

    setItems(previous => [
      ...previous,
      {
        ...product,
        id: Date.now() + Math.random(),
        quantity,
        price,
        vatRate,
        value,
      },
    ]);

    setProduct({
      name: '',
      unit: 'buc',
      quantity: '',
      price: '',
      vatRate: '21',
    });
  };


  const subtotal = items.reduce(
    (sum, item) => sum + item.value,
    0
  );

  const vat = items.reduce(
    (sum, item) =>
      sum + item.value * item.vatRate / 100,
    0
  );

  const total = subtotal + vat;


  return (
    <div className="invoice-creation">

      <div className="invoice-creation-header">
        <h2>
          {content.header || 'Emitere factura'}
        </h2>
        <span>Factura de vanzare</span>
      </div>


      {/* DATE FACTURA */}

      <div className="invoice-creation-grid">

        <label>
          Client / CUI
          <input
            value={form.client}
            onChange={e =>
              updateForm('client', e.target.value)
            }
            placeholder="Denumire sau CUI"
          />
        </label>

        <label>
          Data emiterii
          <input
            type="date"
            value={form.date}
            onChange={e =>
              updateForm('date', e.target.value)
            }
          />
        </label>

        <label>
          Termen de plata
          <input
            type="date"
            value={form.dueDate}
            onChange={e =>
              updateForm('dueDate', e.target.value)
            }
          />
        </label>

        <label>
          Seria
          <input
            value={form.series}
            onChange={e =>
              updateForm('series', e.target.value)
            }
            placeholder="CL"
          />
        </label>

        <label>
          Numar
          <input
            value={form.number}
            onChange={e =>
              updateForm('number', e.target.value)
            }
            placeholder="000125"
          />
        </label>

        <label>
          Moneda
          <select
            value={form.currency}
            onChange={e =>
              updateForm('currency', e.target.value)
            }
          >
            <option value="RON">RON - Leu</option>
            <option value="EUR">EUR - Euro</option>
          </select>
        </label>

      </div>


      {/* ADAUGARE PRODUSE */}

      <h3>Produse si servicii</h3>

      <div className="invoice-product-grid">

        <label className="invoice-product-name">
          Denumire produs / serviciu
          <input
            value={product.name}
            onChange={e =>
              updateProduct('name', e.target.value)
            }
            placeholder="Denumire produs"
          />
        </label>

        <label>
          U.M.
          <select
            value={product.unit}
            onChange={e =>
              updateProduct('unit', e.target.value)
            }
          >
            <option value="buc">buc</option>
            <option value="kg">kg</option>
            <option value="ore">ore</option>
          </select>
        </label>

        <label>
          Cantitate
          <input
            type="number"
            min="0"
            value={product.quantity}
            onChange={e =>
              updateProduct('quantity', e.target.value)
            }
          />
        </label>

        <label>
          Pret (RON)
          <input
            type="number"
            min="0"
            step="0.01"
            value={product.price}
            onChange={e =>
              updateProduct('price', e.target.value)
            }
          />
        </label>

        <label>
          TVA %
          <input
            type="number"
            min="0"
            value={product.vatRate}
            onChange={e =>
              updateProduct('vatRate', e.target.value)
            }
          />
        </label>

      </div>


      <button
        type="button"
        className="invoice-add-button"
        onClick={addProduct}
      >
        + Adauga produs
      </button>


      {/* TABEL FACTURA */}

      <div className="invoice-table-wrapper">

        <table className="invoice-creation-table">

          <thead>
            <tr>
              <th>Produs</th>
              <th>U.M.</th>
              <th>Cant.</th>
              <th>Pret</th>
              <th>Valoare</th>
            </tr>
          </thead>

          <tbody>

            {items.length === 0 ? (
              <tr>
                <td colSpan="5" className="invoice-empty">
                  Adauga primul produs.
                </td>
              </tr>
            ) : (
              items.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.unit}</td>
                  <td>{item.quantity}</td>
                  <td>{item.price.toFixed(2)}</td>
                  <td>{item.value.toFixed(2)}</td>
                </tr>
              ))
            )}

          </tbody>

        </table>

      </div>


      {/* TOTALURI */}

      <div className="invoice-totals">

        <div>
          <span>Subtotal</span>
          <strong>{subtotal.toFixed(2)} RON</strong>
        </div>

        <div>
          <span>TVA</span>
          <strong>{vat.toFixed(2)} RON</strong>
        </div>

        <div className="invoice-grand-total">
          <span>Total factura</span>
          <strong>{total.toFixed(2)} RON</strong>
        </div>

      </div>

    </div>
  );
};


export default InvoiceCreationForm;
